<template>
  <section>
    <!-- 筛选条件 -->
    <el-form :inline="true" class="mt16">
      <el-form-item label="赛事">
        <el-select
          v-model="filters.MatchId"
          placeholder="选择赛事"
          clearable
          filterable
          style="width: 220px"
        >
          <el-option
            v-for="item in matchList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关键字">
        <el-input
          v-model="filters.key"
          placeholder="区域/场馆等"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleSearch"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="primary" @click="handleBatchDelete">
          批量删除
        </el-button>
        <el-button type="primary" @click="handleBatchLock">批量冻结</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="60"></el-table-column>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="MatchName" label="赛事名称"></el-table-column>
      <el-table-column prop="Area" label="区域" width="120"></el-table-column>
      <el-table-column
        prop="RowNumber"
        label="排数"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="SeatNumber"
        label="座位号"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="WxUserInfoId"
        label="微信用户ID"
        width="120"
      ></el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.Status === 0
                ? 'success'
                : scope.row.Status === 1
                ? 'warning'
                : scope.row.Status === 2
                ? 'info'
                : 'danger'
            "
          >
            {{
              scope.row.Status === 0
                ? "可售"
                : scope.row.Status === 1
                ? "已售"
                : scope.row.Status === 2
                ? "冻结/赠送"
                : "锁定"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleView(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="scope.row.Status === 2"
            type="primary"
            size="mini"
            @click="openQr(scope.row)"
            >二维码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>

    <!-- 新增座位 -->
    <el-dialog
      title="新增座位"
      :visible.sync="addFormVisible"
      :close-on-click-modal="false"
      width="600px"
      @closed="resetAddForm"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="赛事" prop="MatchId">
          <el-select
            v-model="addForm.MatchId"
            placeholder="请选择赛事"
            style="width: 100%"
            filterable
            @change="onAddMatchChange"
          >
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次" prop="SessionId" v-if="addForm.MatchId">
          <el-select
            v-model="addForm.SessionId"
            placeholder="请选择场次"
            style="width: 100%"
            filterable
            @change="onAddSessionChange"
          >
            <el-option
              v-for="item in sessionList"
              :key="item.Id"
              :label="item.SessionInfo"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="票档"
          prop="MatchTicketGradeId"
          v-if="addForm.MatchId"
        >
          <el-select
            v-model="addForm.MatchTicketGradeId"
            placeholder="请选择票档"
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in ticketGrades"
              :key="item.Id"
              :label="`${item.GradeName}${
                item.Price != null ? '（¥' + item.Price + '）' : ''
              }`"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域" prop="Area">
          <el-input
            v-model="addForm.Area"
            placeholder="请输入区域名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排数" prop="RowNumber">
          <el-input
            v-model="addForm.RowNumber"
            placeholder="请输入排数"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="起始座位号" prop="StartSeatCount">
          <el-input-number
            v-model="addForm.StartSeatCount"
            :min="1"
            :precision="0"
            placeholder="请输入起始座位号"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="结束座位号" prop="EndSeatCount">
          <el-input-number
            v-model="addForm.EndSeatCount"
            :min="1"
            :precision="0"
            placeholder="请输入结束座位号"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="addForm.Status">
            <el-radio :label="0">可售</el-radio>
            <el-radio :label="1">已售</el-radio>
            <el-radio :label="2">冻结/赠送</el-radio>
            <el-radio :label="3">锁定</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="addSubmit" :loading="addLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 查看座位详情 -->
    <el-dialog
      title="座位详情"
      :visible.sync="detailVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-descriptions :column="2" border v-if="seatDetail">
        <el-descriptions-item label="赛事名称">
          {{ seatDetail.MatchName }}
        </el-descriptions-item>
        <el-descriptions-item label="区域">
          {{ seatDetail.Area }}
        </el-descriptions-item>
        <el-descriptions-item label="微信用户ID">
          {{ seatDetail.WxUserInfoId }}
        </el-descriptions-item>
        <el-descriptions-item label="场馆名称">
          {{ seatDetail.VenueName }}
        </el-descriptions-item>
        <el-descriptions-item label="排数">
          {{ seatDetail.RowNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="座位号">
          {{ seatDetail.SeatNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="购票人姓名">
          {{
            seatDetail.ObjectData && seatDetail.ObjectData.Name
              ? seatDetail.ObjectData.Name
              : ""
          }}
        </el-descriptions-item>
        <el-descriptions-item label="购票人电话">
          {{
            seatDetail.ObjectData && seatDetail.ObjectData.TelPhone
              ? seatDetail.ObjectData.TelPhone
              : ""
          }}
        </el-descriptions-item>
        <el-descriptions-item label="购票人身份证">
          {{
            seatDetail.ObjectData && seatDetail.ObjectData.IdCard
              ? seatDetail.ObjectData.IdCard
              : ""
          }}
        </el-descriptions-item>
        <el-descriptions-item label="价格">
          {{ seatDetail.Price }}
        </el-descriptions-item>
        <el-descriptions-item label="总座位数">
          {{ seatDetail.SeatCount }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag
            :type="
              seatDetail.Status === 0
                ? 'success'
                : seatDetail.Status === 1
                ? 'warning'
                : seatDetail.Status === 2
                ? 'info'
                : 'danger'
            "
          >
            {{
              seatDetail.Status === 0
                ? "可售"
                : seatDetail.Status === 1
                ? "已售"
                : seatDetail.Status === 2
                ? "冻结/赠送"
                : "锁定"
            }}
          </el-tag>
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 微信扫码二维码 -->
    <el-dialog
      title="微信扫码二维码"
      :visible.sync="qrVisible"
      :close-on-click-modal="false"
      width="360px"
    >
      <div class="tc">
        <div v-if="qrLoading" class="p16">生成中...</div>
        <img
          v-else-if="qrDataUrl"
          :src="qrDataUrl"
          alt="二维码"
          style="width: 260px; height: 260px"
        />
        <div v-else class="p16">暂无二维码</div>
      </div>
      <div class="mt16 tc">
        <el-button @click="qrVisible = false">关闭</el-button>
        <el-button type="primary" :disabled="!qrDataUrl" @click="downloadQr"
          >下载图片</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { toDataURL } from "qrcode";
import {
  seatList,
  addSeat,
  deleteSeat,
  batchDeleteSeats,
  batchLockSeats,
  getSeatDetail,
} from "@/api/match/match";
import { matchListAll, ticketList, matchSessionList } from "@/api/match/match";

export default {
  data() {
    return {
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      selectedRows: [], // 选中的行
      // 筛选条件
      filters: {
        MatchId: "",
        key: "",
      },
      // 新增相关
      addFormVisible: false,
      addLoading: false,
      addForm: {
        MatchId: "",
        SessionId: "",
        MatchTicketGradeId: "",
        Area: "",
        RowNumber: "",
        StartSeatCount: 1,
        EndSeatCount: 1,
        Status: 0, // 默认可售
      },
      addFormRules: {
        MatchId: [{ required: true, message: "请选择赛事", trigger: "change" }],
        SessionId: [
          { required: true, message: "请选择场次", trigger: "change" },
        ],
        MatchTicketGradeId: [
          { required: true, message: "请选择票档", trigger: "change" },
        ],
        Area: [{ required: true, message: "请输入区域", trigger: "blur" }],
        RowNumber: [{ required: true, message: "请输入排数", trigger: "blur" }],
        StartSeatCount: [
          { required: true, message: "请输入起始座位号", trigger: "change" },
        ],
        EndSeatCount: [
          { required: true, message: "请输入结束座位号", trigger: "change" },
        ],
        Status: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      // 赛事列表
      matchList: [],
      // 场次列表（按赛事）
      sessionList: [],
      // 票档列表（按赛事过滤）
      ticketGrades: [],
      // 详情相关
      detailVisible: false,
      seatDetail: null,
      // 二维码相关
      qrVisible: false,
      qrLoading: false,
      qrSeat: null,
      qrDataUrl: "",
    };
  },
  mounted() {
    this.getList();
    this.getMatchList();
  },
  methods: {
    // 获取座位列表
    getList() {
      this.listLoading = true;
      let params = {
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      if (this.filters && this.filters.MatchId) {
        params.MatchId = this.filters.MatchId;
      }
      if (this.filters && this.filters.key) {
        params.key = this.filters.key;
      }
      seatList(params)
        .then((res) => {
          if (res.data.success) {
            this.total = res.data.response.dataCount || 0;
            this.list = res.data.response.data || [];
          } else {
            this.$message.error(res.data.message || "获取列表失败");
            this.list = [];
            this.total = 0;
          }
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        });
    },
    // 获取赛事列表
    getMatchList() {
      matchListAll()
        .then((res) => {
          if (res.data.success) {
            this.matchList = res.data.response || [];
          }
        })
        .catch(() => {
          this.matchList = [];
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.currentPage = 1;
      this.getList();
    },
    // 表格选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    // 新增
    handleAdd() {
      this.addFormVisible = true;
    },
    // 新增-赛事切换，联动加载场次
    onAddMatchChange(matchId) {
      this.addForm.SessionId = "";
      this.addForm.MatchTicketGradeId = "";
      this.ticketGrades = [];
      if (matchId) {
        this.fetchSessions(matchId);
      } else {
        this.sessionList = [];
      }
    },
    onAddSessionChange() {
      this.addForm.MatchTicketGradeId = "";
      if (this.addForm.MatchId && this.addForm.SessionId) {
        this.fetchTicketGrades(this.addForm.MatchId, this.addForm.SessionId);
      } else {
        this.ticketGrades = [];
      }
    },
    // 加载场次列表（按赛事）
    fetchSessions(matchId) {
      const params = { matchId: matchId, page: 1, intPageSize: 999 };
      matchSessionList(params)
        .then((res) => {
          if (res && res.data && res.data.success) {
            const resp = res.data.response || {};
            this.sessionList = resp.data || [];
          } else {
            this.sessionList = [];
          }
        })
        .catch(() => {
          this.sessionList = [];
        });
    },
    // 加载票档列表（按赛事+场次）
    fetchTicketGrades(matchId, sessionId) {
      const params = {
        MatchId: matchId,
        matchId: matchId,
        SessionId: sessionId,
        sessionId: sessionId,
        page: 1,
        intPageSize: 999,
      };
      ticketList(params)
        .then((res) => {
          if (res && res.data && res.data.success) {
            const resp = res.data.response || {};
            this.ticketGrades = resp.data || [];
          } else {
            this.ticketGrades = [];
          }
        })
        .catch(() => {
          this.ticketGrades = [];
        });
    },
    // 新增提交
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (
            !Number.isInteger(this.addForm.StartSeatCount) ||
            this.addForm.StartSeatCount < 1
          ) {
            this.$message.error("起始座位号需为大于等于1的整数");
            return;
          }
          if (
            !Number.isInteger(this.addForm.EndSeatCount) ||
            this.addForm.EndSeatCount < 1
          ) {
            this.$message.error("结束座位号需为大于等于1的整数");
            return;
          }
          if (this.addForm.StartSeatCount > this.addForm.EndSeatCount) {
            this.$message.error("起始座位号需≤结束座位号");
            return;
          }
          this.addLoading = true;
          addSeat(this.addForm)
            .then((res) => {
              this.addLoading = false;
              if (res.data.success) {
                this.$message.success("新增成功");
                this.addFormVisible = false;
                this.getList();
              } else {
                this.$message.error(res.data.message || "新增失败");
              }
            })
            .catch(() => {
              this.addLoading = false;
            });
        }
      });
    },
    // 重置新增表单
    resetAddForm() {
      this.$refs.addForm && this.$refs.addForm.resetFields();
      this.addForm = {
        MatchId: "",
        SessionId: "",
        MatchTicketGradeId: "",
        Area: "",
        RowNumber: "",
        StartSeatCount: 1,
        EndSeatCount: 1,
        Status: 0,
      };
      this.sessionList = [];
      this.ticketGrades = [];
    },
    // 查看详情
    handleView(row) {
      this.detailVisible = true;
      this.seatDetail = null;
      getSeatDetail({ Id: row.Id })
        .then((res) => {
          if (res.data.success) {
            this.seatDetail = res.data.response;
          } else {
            this.$message.error(res.data.message || "获取详情失败");
          }
        })
        .catch(() => {
          this.$message.error("获取详情失败");
        });
    },
    // 单个删除
    handleDelete(row) {
      this.$confirm("确认删除该座位吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteSeat({ Id: row.Id })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                this.$message.error(res.data.message || "删除失败");
              }
            })
            .catch(() => {
              this.$message.error("删除失败");
            });
        })
        .catch(() => {});
    },
    // 批量删除
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要删除的座位");
        return;
      }
      this.$confirm("确认删除选中的座位吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.selectedRows.map((item) => item.Id);
          batchDeleteSeats({ ids: ids })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("批量删除成功");
                this.getList();
                this.selectedRows = [];
              } else {
                this.$message.error(res.data.message || "批量删除失败");
              }
            })
            .catch(() => {
              this.$message.error("批量删除失败");
            });
        })
        .catch(() => {});
    },
    // 批量冻结
    handleBatchLock() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要冻结的座位");
        return;
      }
      this.$confirm("确认冻结选中的座位吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const ids = this.selectedRows.map((item) => item.Id);
          batchLockSeats({ ids: ids })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("批量冻结成功");
                this.getList();
                this.selectedRows = [];
              } else {
                this.$message.error(res.data.message || "批量冻结失败");
              }
            })
            .catch(() => {
              this.$message.error("批量冻结失败");
            });
        })
        .catch(() => {});
    },
    // Toolbar 按钮回调
    callFunction(item) {
      this.filters = Object.assign({}, this.filters, { key: item.search });
      if (item.Func && this[item.Func]) {
        this[item.Func].apply(this, item);
      }
    },
    // 查询
    handleSearch() {
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      this.filters = {
        MatchId: "",
        key: "",
      };
      this.page.currentPage = 1;
      this.getList();
    },
    // 打开二维码弹窗（锁定座位）
    openQr(row) {
      this.qrVisible = true;
      this.qrLoading = true;
      this.qrSeat = row;
      // 生成 H5 页面地址，包含 seatId 参数
      const h5Url = `https://admin-zheliyundong.scqtkj.com/h5/seat?seatId=${row.Id}`;
      toDataURL(h5Url, { width: 260, margin: 2 })
        .then((url) => {
          this.qrDataUrl = url;
          this.qrLoading = false;
        })
        .catch(() => {
          this.$message.error("二维码生成失败");
          this.qrLoading = false;
        });
    },
    // 下载二维码图片
    downloadQr() {
      if (!this.qrDataUrl || !this.qrSeat) return;
      const link = document.createElement("a");
      link.href = this.qrDataUrl;
      link.download = `seat_${this.qrSeat.Id}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt16 {
  margin-top: 16px;
}
.p16 {
  padding: 16px;
}
.tc {
  text-align: center;
}
</style>
